'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const Guid=require('pulsar-utils/dist-es6/domain/guid');let

ValidatedFieldDirective=function(_BaseControllerBacked){_inherits(ValidatedFieldDirective,_BaseControllerBacked);function ValidatedFieldDirective(){_classCallCheck(this,ValidatedFieldDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ValidatedFieldDirective,[{key:'restrict',get:function()
{
return'A';
}},{key:'objectBindings',get:function()

{
return['form','value','submissionResult','customErrorHandler','isDisabled','disabledClassOnly','isTextArea'];
}},{key:'textBindings',get:function()

{
return['label','propertyName','placeholder','type','fieldId'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/validatedFieldDirective/validatedFieldTemplate';
}},{key:'controller',get:function()

{
return ValidatedFieldController;
}}]);return ValidatedFieldDirective}(BaseControllerBackedDirective);let


ValidatedFieldController=function(){_createClass(ValidatedFieldController,null,[{key:'$inject',get:function()
{
return['$scope'];
}}]);

function ValidatedFieldController($scope){var _this2=this;_classCallCheck(this,ValidatedFieldController);
this._defaultErrorMessage=this._requiredFieldMessage();

this.type=this.type||'text';
this.fieldId=this.fieldId||Guid.create().toString();

this.isDisabled=this.isDisabled||!1;
this.disabledClassOnly=this.disabledClassOnly||!1;
this.isTextArea=this.isTextArea||!1;

this.placeholder=this.placeholder||'';
this.label=this.label||'';

$scope.$watch('controller.submissionResult',function(result){return _this2._displaySubmissionErrors(result)});

$scope.$watch('controller.value',function(){
if(!_this2.fieldIsTouchedAndInvalid){
_this2._resetErrorMessage();
}
});
}ValidatedFieldController.prototype.

















_resetErrorMessage=function _resetErrorMessage(){
this._errorMessage=void 0;
};ValidatedFieldController.prototype.

_displaySubmissionErrors=function _displaySubmissionErrors(submissionResult){
this._resetErrorMessage();

if(_.exists(submissionResult)){
if(_.exists(this.customErrorHandler)){
let customErrorMessage=this.customErrorHandler(submissionResult);

if(_.exists(customErrorMessage)){
this._errorMessage=customErrorMessage;
return;
}
}

if(submissionResult.status==='HttpError'&&submissionResult.body.httpStatus===422){
this._errorMessage=this._findSchemaError(submissionResult.body.errors);
}
}
};ValidatedFieldController.prototype.

_findSchemaError=function _findSchemaError(errorsArray){
for(let error of errorsArray){
if(error.indexOf(this.propertyName)>-1){
if(/requires property/gi.test(error)){
return this._requiredFieldMessage();
}
if(/does not conform/gi.test(error)){
return this._invalidFieldMessage();
}
}
}

return void 0;
};ValidatedFieldController.prototype.

_invalidFieldMessage=function _invalidFieldMessage(){
return`Please enter a valid ${this.label.toLowerCase()}.`;
};ValidatedFieldController.prototype.

_requiredFieldMessage=function _requiredFieldMessage(){
return`${_.upperFirst(this.label)} is a required field.`;
};_createClass(ValidatedFieldController,[{key:'fieldIsTouchedAndInvalid',get:function(){if(!_.exists(this.form[this.fieldId])){return!1}return this.form[this.fieldId].$touched&&this.form[this.fieldId].$invalid}},{key:'defaultErrorMessage',get:function(){return this._defaultErrorMessage}},{key:'errorMessage',get:function(){return this._errorMessage}}]);return ValidatedFieldController}();


module.exports=ValidatedFieldDirective;
module.exports.controller=ValidatedFieldController;
//# sourceMappingURL=validatedFieldDirective.js.map
